export default "__VITE_ASSET__DYE7reKb__"